import type { CSSProperties } from "react";
import type { Tag } from "schemas";
import { type IconType, PureIcon } from "ui";

const tagStyles: CSSProperties = {
  display: "inline-block",
  marginRight: "8px",
  verticalAlign: "middle",
  padding: "4px 8px",
  borderRadius: "14px",
  backgroundColor: "#FEF7EC",
  border: "1px solid #F9CC8E",
  fontSize: "12px",
  lineHeight: "20px",
  fontWeight: "500",
  color: "#465357",
};

const tagsContainerStyles: CSSProperties = {
  marginTop: "8px",
};

interface Props {
  tags: Tag[];
}
export function Tags({ tags }: Props) {
  return (
    <div style={tagsContainerStyles}>
      {tags.map(({ label, iconType }) => (
        <div key={`${label}-${iconType}`} style={tagStyles}>
          <span style={{ display: "inline-block", height: "20px", verticalAlign: "middle" }}>
            <PureIcon iconType={iconType as IconType} />
          </span>
          <span style={{ verticalAlign: "middle", marginLeft: "4px" }}>{label}</span>
        </div>
      ))}
    </div>
  );
}
